import request from './request';

// 登录状态
export const loginStatus=() => {
    return request({
        url:"/website/index",
        method:"GET"
    })
}
// 退出登录
export const logout=() => {
    return request({
        url:"/website/member/logout",
        method:"POST"
    })
}
// 首页统计图
export const chart=() => {
    return request({
        url:"/website/data",
        method:"POST"
    })
}
// 公告列表
export const newsList=() => {
    return request({
        url:"/website/news/list",
        method:"POST"
    })
}
// 公告详情
export const newsDetail=(postData)=> {
    return request({
        url:"/website/news/detail",
        method:"POST",
        data: postData,
    })
}


// WEBPACK FOOTER //
// ./src/util/home.js